// Copyright (c) 2016 Deere & Company

import actions from '../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';
import {readLaborTypes} from '../../../shared/action-creators/labor-types';

const isHomeDepotRetailer = key => ['0002000001', '0002000004'].some(retailerKey => retailerKey === key);

const isHomeDepotUs = key => ['0002000001'].some(retailerKey => retailerKey === key);

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection) =>
    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_RESPONSIBLE_ACCOUNTS
        });

        if (accountId) {

            readLaborTypes(accountId)(dispatch);

        }

    };

export const updateMassChannelPdiClaimProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_PROPERTY,
    value
});

export const updateMassChannelPdiClaimReferenceInfoProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_REFERENCE_INFO_PROPERTY,
    value
});

export const updateGoodsInstallationVatDropDown = (key, goodsInstallationOptions) => ({
    goodsInstallationOptions,
    key,
    type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_GOODS_INSTALLATION_VAT
});

export const updateMassChannelPdiClaimInputOnBlur = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION,
    validity: mapFormValidation(property, value)
});

export const updateRetailerNameDropDown = (key, retailerNameCollection) =>
    dispatch => {

        dispatch({
            key,
            retailerNameCollection,
            type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME
        });

        if (!isHomeDepotRetailer(key)) {

            dispatch({
                property: 'referenceNumber3',
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_PROPERTY,
                value: ''
            });

            dispatch({
                property: 'workOrderThree',
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION,
                validity: true
            });

            dispatch({
                property: 'purchaseOrderNumber',
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_PROPERTY,
                value: ''
            });

            dispatch({
                property: 'purchaseOrder',
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION,
                validity: true
            });

        }

        if (!isHomeDepotUs(key)) {

            dispatch({
                property: 'referenceNumber3',
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_PROPERTY,
                value: ''
            });

            dispatch({
                property: 'workOrderThree',
                type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_FORM_VALIDATION,
                validity: true
            });

        }

    };

export const resetMassChannelPdiClaim = () => ({
    type: actions.RESET_CLAIM_MASS_CHANNEL_PDI
});

export const updateMassChannelPdiPin = (index, value) =>
    (dispatch, getState) => {

        const numberOfPins = getState().claims.massChannelPdi.claim.pins.length;

        dispatch({
            index,
            type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_PIN,
            value
        });

        if (index > (numberOfPins - 4)) {

            dispatch({
                type: actions.ADD_CLAIM_MASS_CHANNEL_PDI_PINS
            });

        }

    };

export const updateStickyHeaderVisibility = status =>
    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/action-creators/claim-details.js